import $ from "jquery";

export function update_aria()
{
    //Update the menu aria-current page based on urls
    let url = window.location.href;
    $('.nav-menu li.current-menu-item').removeClass('current-menu-item');

    let active_items = $('.nav-menu').find('a[href="' + url + '"]');

    active_items.each(function(){
        $(this).parent().addClass('current-menu-item');
    });

}

export function setup_menu()
{
    let body = $('body');

    $('.mobile-menu-trigger').on('click', function()
    {
        console.log('test');
        if( body.hasClass('menu-open') )
        {
            body.removeClass('menu-open');
        }
        else
        {
            body.addClass('menu-open');
        }
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/menu.js